module.exports = __webpack_public_path__ + "img/section1Swiper1.091cdad9.png";